import z from 'zod';

export const AddressSchema = z.object({
  text: z.string(),
  city: z.string(),
  state: z.string(),
  country: z.string(),
  postalCode: z.string(),
  lat: z.number(),
  lng: z.number(),
});

export type Address = z.infer<typeof AddressSchema>;
